import { render, staticRenderFns } from "./DiagnosticSummary.vue?vue&type=template&id=08bd4b66&scoped=true"
import script from "./DiagnosticSummary.vue?vue&type=script&lang=js"
export * from "./DiagnosticSummary.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticSummary.vue?vue&type=style&index=0&id=08bd4b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bd4b66",
  null
  
)

export default component.exports